import { HolderOutlined } from "@ant-design/icons";
import { Reorder } from "motion/react";
import "./AcquirerPriorityList.scss";

const AcquirerPriorityList = ({ value = [], labels = {}, disabled = false, onChange }) => {
    const renderRow = (code, index) => (
        <>
            <span className="position">{index + 1}</span>
            <span className="name">{labels[code] || code}</span>
            {!disabled && <HolderOutlined className="handle" />}
        </>
    );

    if (disabled) {
        return (
            <ul className="AcquirerPriorityList is-disabled">
                {value.map((code, index) => (
                    <li key={code} className="item">
                        {renderRow(code, index)}
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <Reorder.Group axis="y" values={value} onReorder={onChange} className="AcquirerPriorityList">
            {value.map((code, index) => (
                <Reorder.Item key={code} value={code} className="item">
                    {renderRow(code, index)}
                </Reorder.Item>
            ))}
        </Reorder.Group>
    );
};

export default AcquirerPriorityList;
